// Rounded down, so the copy never promises more time than the reporter has.
export const formatEditTimeLeft = (msLeft: number): string => {
  const minutes = Math.floor(msLeft / 60_000);
  if (minutes < 1) return 'You can edit this ticket for less than a minute.';
  return `You can edit this ticket for ${minutes} more ${minutes === 1 ? 'minute' : 'minutes'}.`;
};
